// Selection helpers for EvidenceModal

// Find the Typography segment element from a descendant node
export function getSegmentElementFromNode(contentRoot, node) {
    if (!contentRoot || !node) return null;
    let n = node.nodeType === 3 ? node.parentNode : node;
    while (n && n !== contentRoot) {
        if (n.nodeType === 1 && typeof n.id === 'string' && /^segment-\d+$/.test(n.id)) {
            return n;
        }
        n = n.parentNode;
    }
    return null;
}

export function parseIndexFromSegmentId(id) {
    if (!id) return null;
    const m = id.match(/^segment-(\d+)$/);
    return m ? Number(m[1]) : null;
}

// Computes the character offset within a segment element for a given text node and offset
export function getOffsetWithinSegment(segmentEl, node, nodeOffset) {
    if (!segmentEl || !node || typeof nodeOffset !== 'number') return 0;
    try {
        const range = window.document.createRange();
        range.setStart(segmentEl, 0);
        range.setEnd(node, nodeOffset);
        return range.toString().length;
    } catch (e) {
        const walker = window.document.createTreeWalker(segmentEl, NodeFilter.SHOW_TEXT);
        let total = 0;
        let current;
        while ((current = walker.nextNode())) {
            if (current === node) {
                total += nodeOffset;
                break;
            }
            total += current.nodeValue?.length ?? 0;
        }
        return total;
    }
}

// Compute word range around an offset within given text
export function computeWordRange(text = '', offset = 0) {
    const len = text.length;
    if (!len) return [0, 0];
    let i = Math.max(0, Math.min(len, offset));
    // Expand left to word boundary
    let l = i;
    while (l > 0 && /\w/.test(text[l - 1])) l--;
    // Expand right to word boundary
    let r = i;
    while (r < len && /\w/.test(text[r])) r++;
    // Fallback: if no word characters around, highlight a small window
    if (l === r) {
        l = Math.max(0, i - 3);
        r = Math.min(len, i + 3);
    }
    return [l, r];
}
